module.exports = __webpack_public_path__ + "img/logo-priemvuz-white-footer.8196993d.svg";